import { useCallback, useState } from 'react';

const STORAGE_KEY = 'nexus-nav-chrome-collapsed';

function readCollapsed(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    try {
        return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        return false;
    }
}

function writeCollapsed(collapsed: boolean): void {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        window.localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
    } catch {
        // quota / private mode
    }
}

/** Preferência global: ocultar barra de atalhos + breadcrumb do shell Nexus. */
export function useNavChromeCollapsed() {
    const [collapsed, setCollapsedState] = useState(readCollapsed);

    const setCollapsed = useCallback((next: boolean) => {
        setCollapsedState(next);
        writeCollapsed(next);
    }, []);

    const toggle = useCallback(() => {
        setCollapsedState((prev) => {
            const next = !prev;
            writeCollapsed(next);
            return next;
        });
    }, []);

    return { collapsed, setCollapsed, toggle };
}
